'use strict';

/* global window */

const locales = require('./locales');

module.exports = {
  getTranslation: (translationRequest) => {
    if (window.translationStore && window.translationStore.getTranslation) {
      return window.translationStore.getTranslation(translationRequest);
    }

    throw new Error('window.translationStore.getTranslation was not found. Ensure that the `getSource` function from the translation store is being used to generate a client-side translation function and that the code is being saved to a file and imported into the page in the browser.');
  },

  locales
};